module.exports = __webpack_public_path__ + "static/media/JosefinSans-Bold.e314da2c.ttf";